import { ArtefactKind } from "@/services/backend/artefacts/kind";

/**
 * processMilestoneLink builds the deep link to the artefact a process is
 * currently sitting on. The delivery milestone has no artefact id in its
 * route, therefore it is handled separately.
 */
export function processMilestoneLink(process: {
  id: string;
  currentMilestone: string;
  currentMilestoneId: string;
}): string {
  return process.currentMilestone === ArtefactKind.Delivery
    ? `/processes/${process.id}/${process.currentMilestone}`
    : `/processes/${process.id}/${process.currentMilestone}/${process.currentMilestoneId}`;
}
